import styled from "styled-components";
import {TextareaProps} from "@FRAMEWORK/ui/types/d";

interface Props extends TextareaProps {
	width?: string;
	height?: string;
}

const TextareaSelect = styled.textarea<{width?: string; height?: string}>`
	display: block;
	width: ${props => (props.width ? props.width : "100%")};
	height: ${props => (props.height ? props.height : "")};
	line-height: 1.2;
	padding: 15px;
	border: 1px solid var(--line-color);
	appearance: none;
	box-shadow: none;
	border-radius: 0;
	box-sizing: border-box;
	-webkit-text-size-adjust: none;
	-webkit-border-radius: none;
	-webkit-appearance: none;
	color: var(--default-color);
	resize: none;
	white-space: pre-wrap;

	&:disabled {
		background-color: var(--disabled-color);
	}
	&:focus {
		border-color: currentColor;
		outline: 1px solid currentColor;
	}
`;

const Textarea = ({width, height, ...props}: Props) => <TextareaSelect width={width} height={height} {...props} />;

export default Textarea;
